// extracted by mini-css-extract-plugin
export default {"ModelFilterSelect":"ShoesFilterSelection_ModelFilterSelect__C15Q0","ModelFilterSelect_tag":"ShoesFilterSelection_ModelFilterSelect_tag__Gt2c-"};